import { i18n } from "app/i18n/i18n";
import { toUTCDate } from "lib/dateUtils";
import { createReportUrl } from "pages/latestResearch/publications/urls/publicationUrls";
import { getKeywordOrTitle } from "lib/routing";
import { getProdCopyUrl } from "pages/redesign/preferences/redesignUtils";
import { timeAgo } from "lib/timeAgo";

// TODO refactor legacy. Moves highlight fields into source
export const mutateHighlightFields = (data) => {
  const lang = i18n.getLanguage();
  const isExactSearch = getKeywordOrTitle()?.includes('"');

  data?.hits?.hits.forEach((q) => {
    if (q.highlight) {
      q._source.Highlight = {};
      q._source.Highlight.content = q.highlight["content.body"] || null;
      q._source.Highlight.title = q.highlight["title"] || null;
      q._source.Highlight.colour = lang === "en" || isExactSearch ? "highlight-text-yellow" : "none";
    }
  });
};

export const parsePublications = (data) => {
  const lang = i18n.getLanguage();
  const hits = data?.hits?.hits;
  if (!hits?.length) return [];

  return hits.map((hit) => update(hit._source, lang));
};

function update(pub, lang) {
  pub.publicationDateLocale = timeAgo(toUTCDate(pub.publicationDate), lang);
  pub.PageCount = pub.pageCount;
  delete pub.pageCount;

  const appName = "GRPUI";
  const cid = "";
  const japi = getProdCopyUrl();

  pub.commonEndpoint = createReportUrl(pub.id, "", appName, cid, japi); // main publication link
  pub.pdfUrl = createReportUrl(pub.id, ".file", appName, cid, japi); // download as PDF
  pub.htmlUrl = existsHtmlFormat(pub) ? createReportUrl(pub.id, ".html", appName, cid, japi) : null; //used only for labelling
  pub.pubUrl = pub.podcastUrl || pub.commonEndpoint;
  pub.sm = 12; // publication small device width is full screen

  return pub;
}

export const existsHtmlFormat = ({ resources = [] }) =>
  resources.filter((res) => res.isCDNReady && res.format === "html5").length > 0;
export const existsExternal = ({ resources = [] }) =>
  resources.filter((res) => res.isCDNReady && res.format === "external").length > 0;
export const isPodcastUrl = ({ resources = [] }) =>
  resources.filter((res) => res.isCDNReady && (res.extension === ".mp3" || res.extension === ".mp4")).length > 0;

export const parseAggregations = (aggregations = {}) => {
  if (aggregations["analysts.name.en"]?.["activeAnalysts"]) {
    aggregations["analysts.name.en"] = aggregations?.["analysts.name.en"]?.["activeAnalysts"];
  }
  if (aggregations["analysts.name.ja"]?.["activeAnalysts"]) {
    aggregations["analysts.name.ja"] = aggregations?.["analysts.name.ja"]?.["activeAnalysts"];
  }

  return Object.entries(aggregations).reduce((acc, [key, value]) => {
    acc[key] = value.buckets.filter((item) => !!item);
    return acc;
  }, {});
};
